// AI Generated Component
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

import { FormSourceCodeExcludeComponent } from './source-code-exclude/form-source-code-exclude.component';
import { FormSourceCodeExcludeStepsModuleComponent } from './source-code-exclude/steps/module/module.component';
import { FormSourceCodeExcludeStepsFormComponent } from './source-code-exclude/steps/form/form-source-code-exclude-steps-form.component';
import { FormSourceCodeExcludeAccessibilityComponent } from './source-code-exclude/modules/accessibility/form-source-code-exclude-accessibility.component';
import { FormSourceCodeExcludeSceComponent } from './source-code-exclude/modules/source-code-exclude/form-source-code-exclude-sce.component';
import { ValidateCssSelectorDirective } from '@client/app/directives/validate-css-selector/validate-css-selector.directive';

// Import shared modules
import { ComponentsModule } from '@client/app/components/components.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { SharedModule } from '@client/ng2/shared/shared.module';
import { LayoutModule } from '@monsido/angular-shared-components';
import { ModalsDirectivesModule } from '@client/app/modules/modals/directives/modals-directives.module';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        FormSourceCodeExcludeComponent,
        FormSourceCodeExcludeStepsModuleComponent,
        FormSourceCodeExcludeStepsFormComponent,
        FormSourceCodeExcludeAccessibilityComponent,
        FormSourceCodeExcludeSceComponent,
        ValidateCssSelectorDirective,
    ],
    imports: [
        FormsModule,
        TranslateModule,
        ComponentsModule,
        UpgradePipeModule,
        CommonModule,
        SharedModule,
        NgbModule,
        LayoutModule,
        ModalsDirectivesModule,
    ],
    exports: [
        FormSourceCodeExcludeComponent,
        FormSourceCodeExcludeStepsModuleComponent,
        FormSourceCodeExcludeStepsFormComponent,
        FormSourceCodeExcludeAccessibilityComponent,
        FormSourceCodeExcludeSceComponent,
    ],
})
export class FormSourceCodeExcludeModule {}
